/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Status_WaitingInputs */

const th_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เชื่อมต่อแล้ว รอให้มีคนถ่ายทอดสดเกมนี้`)
};

const en_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected. Waiting for somebody to broadcast this game.`)
};

const ja_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続済み。誰かがこの試合を配信するのを待っています。`)
};

const zh_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已连接。正在等待有人直播这场比赛。`)
};

const es_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectado. Esperando a que alguien retransmita este partido.`)
};

const pt_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectado. Aguardando alguém transmitir este jogo.`)
};

const id_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terhubung. Menunggu seseorang menyiarkan pertandingan ini.`)
};

const fr_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecté. En attente de quelqu’un pour diffuser ce match.`)
};

const tl_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konektado. Hinihintay ang magsasahimpapawid ng larong ito.`)
};

const vi_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kết nối. Đang đợi ai đó phát trận này.`)
};

const ko_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결되었습니다. 누군가 이 경기를 중계하기를 기다리는 중입니다.`)
};

const de_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbunden. Warte darauf, dass jemand dieses Spiel überträgt.`)
};

const ru_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключено. Ждём, когда кто-нибудь начнёт транслировать этот матч.`)
};

const tr_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlandı. Birinin bu maçı yayınlamasını bekliyor.`)
};

const it_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connesso. In attesa che qualcuno trasmetta questa partita.`)
};

const pl_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Połączono. Czekamy, aż ktoś zacznie transmitować ten mecz.`)
};

const uk_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підключено. Чекаємо, поки хтось почне транслювати цей матч.`)
};

const hi_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जुड़ गया। प्रतीक्षा है कि कोई इस मैच को प्रसारित करे।`)
};

const ar_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متصل. بانتظار أن يبثّ أحد هذه المباراة.`)
};

const ms_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bersambung. Menunggu seseorang menyiarkan perlawanan ini.`)
};

const bn_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যুক্ত হয়েছে। কেউ এই খেলা সম্প্রচার করার অপেক্ষায়।`)
};

const zh_tw2_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已連線。正在等待有人轉播這場比賽。`)
};

const zh_hk2_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已連線。正在等待有人轉播這場比賽。`)
};

const ur_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جڑ گیا۔ انتظار ہے کہ کوئی یہ میچ نشر کرے۔`)
};

const fa_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متصل شد. در انتظار کسی که این بازی را پخش کند.`)
};

const sw_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imeunganishwa. Inasubiri mtu arushe mchezo huu.`)
};

const nl_video_status_waiting = /** @type {(inputs: Video_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbonden. Wachten tot iemand deze wedstrijd uitzendt.`)
};

/**
* | output |
* | --- |
* | "Connected. Waiting for somebody to broadcast this game." |
*
* @param {Video_Status_WaitingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_status_waiting = /** @type {((inputs?: Video_Status_WaitingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Status_WaitingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_status_waiting(inputs)
	if (locale === "ja") return ja_video_status_waiting(inputs)
	if (locale === "zh") return zh_video_status_waiting(inputs)
	if (locale === "es") return es_video_status_waiting(inputs)
	if (locale === "pt") return pt_video_status_waiting(inputs)
	if (locale === "id") return id_video_status_waiting(inputs)
	if (locale === "fr") return fr_video_status_waiting(inputs)
	if (locale === "tl") return tl_video_status_waiting(inputs)
	if (locale === "vi") return vi_video_status_waiting(inputs)
	if (locale === "ko") return ko_video_status_waiting(inputs)
	if (locale === "de") return de_video_status_waiting(inputs)
	if (locale === "ru") return ru_video_status_waiting(inputs)
	if (locale === "tr") return tr_video_status_waiting(inputs)
	if (locale === "it") return it_video_status_waiting(inputs)
	if (locale === "pl") return pl_video_status_waiting(inputs)
	if (locale === "uk") return uk_video_status_waiting(inputs)
	if (locale === "hi") return hi_video_status_waiting(inputs)
	if (locale === "ar") return ar_video_status_waiting(inputs)
	if (locale === "ms") return ms_video_status_waiting(inputs)
	if (locale === "bn") return bn_video_status_waiting(inputs)
	if (locale === "zh-TW") return zh_tw2_video_status_waiting(inputs)
	if (locale === "zh-HK") return zh_hk2_video_status_waiting(inputs)
	if (locale === "ur") return ur_video_status_waiting(inputs)
	if (locale === "fa") return fa_video_status_waiting(inputs)
	if (locale === "sw") return sw_video_status_waiting(inputs)
	if (locale === "nl") return nl_video_status_waiting(inputs)
	return en_video_status_waiting(inputs)
});